// @flow
import Footer from './Footer';
export default Footer;



// WEBPACK FOOTER //
// ./src/components/Layout/components/Footer/index.js